import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class MonitoringControllerService {
  constructor(private readonly http: HttpClient) {}

  public getFEVersion() {
    return this.http.get('/version', {
      headers: { ignoreLoadingBar: '' }
    }) as Observable<any>;
  }
}
